type NativeOtpPayload = {
  otp?: string | number;
  code?: string | number;
  otpCode?: string | number;
  message?: string | number;
};

type OtpListener = (otp: string) => void;

const listeners = new Set<OtpListener>();

declare global {
  interface Window {
    /**
     * AOS가 SMS에서 읽은 인증번호를 웹으로 전달할 때 호출한다.
     * 예: handleOtp("123456") / handleOtp({ otp: "123456" })
     */
    handleOtp: (data: string | NativeOtpPayload) => void;
  }
}

export function subscribeNativeOtp(listener: OtpListener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function parsePayload(data: string | NativeOtpPayload): unknown {
  if (typeof data !== "string") return data;

  const trimmed = data.trim();
  if (trimmed.startsWith("{")) {
    try {
      return JSON.parse(trimmed);
    } catch {
      return trimmed;
    }
  }
  return trimmed;
}

/** SMS 본문/브릿지 payload에서 6자리 인증번호를 추출한다. */
export function extractOtp(data: string | NativeOtpPayload): string | null {
  const parsed = parsePayload(data);
  let raw = "";

  if (typeof parsed === "string" || typeof parsed === "number") {
    raw = String(parsed);
  } else if (parsed && typeof parsed === "object") {
    const payload = parsed as NativeOtpPayload;
    const candidate = payload.otp ?? payload.code ?? payload.otpCode ?? payload.message;
    if (candidate != null) raw = String(candidate);
  }

  const match = raw.match(/\d{6}/);
  return match?.[0] ?? null;
}

/**
 * 네이티브(AOS)에서 SMS 인증번호를 읽은 뒤 호출하는 App -> Web 브릿지.
 */
window.handleOtp = (data: string | NativeOtpPayload): void => {
  try {
    const otp = extractOtp(data);
    if (!otp) {
      console.error("handleOtp: 인증번호를 찾지 못했습니다.", data);
      return;
    }
    listeners.forEach((listener) => listener(otp));
  } catch (error) {
    console.error(error, "handleOtp 오류");
  }
};

export {};
